// src/constants/roles.ts
export type Role = 'admin' | 'supervisor' | 'operator' | 'viewer' | 'auditor' | 'manager' | 'maintenance' | 'safety' | 'it' | 'poweruser';

export const ROLES = {
  super_admin: {
    label: 'Super Admin',
    id: 1,
    roleName: 'superAdmin',
  },
  shiftSupervisor: {
    label: 'Shift Supervisor',
    id: 2,
    roleName: 'shiftSupervisor',
  },
  responsiblePerson: {
    label: 'Responsible Person',
    id: 3,
    roleName: 'responsiblePerson',
  },
  appointedOperator: {
    label: 'Appointed Operator',
    id: 4,
    roleName: 'appointedOperator',
  },
  hotWorkMonitor: {
    label: 'Hot Work Monitor',
    id: 5,
    roleName: 'hotWorkMonitor',
  },
  systemEngineer: {
    label: 'System Engineer',
    id: 6,
    roleName: 'systemEngineer',
  },
  sectionHead: {
    label: 'Section Head',
    id: 7,
    roleName: 'sectionHead',
  },
  technicalManager: {
    label: 'Technical Manager',
    id: 8,
    roleName: 'technicalManager',
  },
  operationManager: {
    label: 'Operation Manager',
    id: 9,
    roleName: 'operationManager',
  },
  planner: {
    label: 'Planner',
    id: 10,
    roleName: 'planner',
  },
  technicalSupportOfficer: {
    label: 'Technical Support Officer',
    id: 11,
    roleName: 'technicalSupportOfficer',
  },
  requestor: {
    label: 'Requestor',
    id: 12,
    roleName: 'requestor',
  },
  maintenanceManager: {
    label: 'Maintenance Manager',
    id: 13,
    roleName: 'maintenanceManager',
  },
  shiftAssistant: {
    label: 'Shift Assistant',
    id: 20,
    roleName: 'shiftAssistant',
  },
  shiftTrainee: {
    label: 'Shift Trainee',
    id: 21,
    roleName: 'shiftTrainee',
  },
};

export const READ_ONLY_SHIFT_LOG_ROLES = ['shift_assistant', 'shift_trainee'] as const;

export const isReadOnlyShiftLogRole = (role?: string | null) =>
  READ_ONLY_SHIFT_LOG_ROLES.includes(role as (typeof READ_ONLY_SHIFT_LOG_ROLES)[number]);
export const ROLE_LIST = [
  ROLES.super_admin.roleName,
  ROLES.shiftSupervisor.roleName,
  ROLES.responsiblePerson.roleName,
  ROLES.appointedOperator.roleName,
  ROLES.hotWorkMonitor.roleName,
  ROLES.systemEngineer.roleName,
  ROLES.sectionHead.roleName,
  ROLES.technicalManager.roleName,
  ROLES.operationManager.roleName,
  ROLES.planner.roleName,
  ROLES.technicalSupportOfficer.roleName,
  ROLES.requestor.roleName,
  ROLES.maintenanceManager.roleName,
  ROLES.shiftAssistant.roleName,
  ROLES.shiftTrainee.roleName,
];

export const ROLE_ACCESS: Record<string, string[]> = {
  admin: ['dashboard', 'clipboard', 'layers', 'alerts', 'files', 'settings'],
  supervisor: ['dashboard', 'clipboard', 'layers'],
  operator: ['dashboard', 'alerts'],
  viewer: ['dashboard'],
  // ...other roles
};
